<template>
  <div>
    <h1 class="uk-text-primary uk-text-center margin-top-negative">{{ title }}</h1>
    <div class="uk-text-center">
      <video
        ref="videoPlayerRef"
        :id="videoPlayerName+frameNum"
        type="video/mp4"
        @play="removeControls"
        @ended="resetVideo"
        @timeupdate="supposedTimeUpdate"
        @seeking="hasSeeked"
        :src="src"
        :width="vidwidth+'%'"
        :height="videoheight"
        :controls="controlsShow">
      </video>
    </div>
    <div v-if="videoCompleted" class="uk-align-center  uk-text-center uk-animation-scale-down btn-extra-large-text">
      <button @click="showTest" class="uk-button uk-button-primary navigate-frame-btn ">Continue<span uk-icon="icon: chevron-right; ratio: 2"></span></button>
    </div>
  </div>
</template>

<script>

export default {
  name: 'VideoContext',
  props: {
    title: {
      type: String,
      default:"default"
    },
    src: {
      type: String,
      default:"http://techslides.com/demos/sample-videos/small.mp4"
    },
    videowidth: {
      type: Number,
      default: 83
    },
    videoheight: {
      type: Number,
      default: 480
    },
    frameNum:{
      type: Number,
      default: 0
    },
    nextFrame: {
      type: Function
    }
  },
  data () {
      return {
          videoPlayerName:'videoPlayer',
          display:'none',
          videoStarted: false,
          videoCompleted: false,
          controlsShow: true,
          width: window.innerWidth,
          videoEnlarged: false,
          vidwidth: this.videowidth,
          supposedCurrentTime: 0
      }
  },
  computed: {
    playersizetext(){
      return this.videoEnlarged === false ? "maximize" : "minimize"
    }
  },
  methods: {
    playVideo(){
      this.$refs.videoPlayerRef.play()
    },
    showTest(){
      this.nextFrame(this.frameNum+1)
    },
    removeControls(){
      this.controlsShow = true;
      this.contextMenu = false;
      this.videoStarted = true;
    },
    resetVideo(){
      this.supposedCurrentTime = 0
      this.videoCompleted = true;
      this.controlsShow = true;
      this.contextMenuShow = true;
    },
    supposedTimeUpdate(){
      if(!this.$refs.videoPlayerRef.seeking){
        this.supposedCurrentTime = this.$refs.videoPlayerRef.currentTime
      }
    },
    hasSeeked(){
      let time_difference = this.$refs.videoPlayerRef.currentTime - this.supposedCurrentTime;
      if(time_difference > 0){
        this.$refs.videoPlayerRef.currentTime = this.supposedCurrentTime
      }
    },
    requestFullscreenVideo(){
      this.videoEnlarged = !this.videoEnlarged;
      this.videoEnlarged === false ? this.vidwidth = 720 : this.vidwidth = 2200;
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .margin-top-negative {
    margin-top: -35px;
  }
</style>





